// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button-sm[data-v-7c5b8cc4]{height:35px;width:35px;font-size:.875rem;padding:.7rem}.p-component[data-v-7c5b8cc4]:disabled,.p-disabled[data-v-7c5b8cc4]{opacity:.8}.p-dropdown[data-v-7c5b8cc4]{min-width:200px}.hover-container[data-v-7c5b8cc4]{position:relative;display:flex;justify-content:between;align-items:center}.delete-button[data-v-7c5b8cc4]{position:absolute;top:0;right:0;visibility:hidden;z-index:10}.hover-container:hover .delete-button[data-v-7c5b8cc4]{visibility:visible}", ""]);
// Exports
module.exports = exports;
